import { render, staticRenderFns } from "./FollowInvited.vue?vue&type=template&id=4ecd078e&scoped=true"
import script from "./FollowInvited.vue?vue&type=script&lang=js"
export * from "./FollowInvited.vue?vue&type=script&lang=js"
import style0 from "./FollowInvited.vue?vue&type=style&index=0&id=4ecd078e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd078e",
  null
  
)

export default component.exports